import { PaymentOption, VacuumOption } from "../../types/vacuum.types";

export enum PAGES {
  START_PAGE = 0,
  VACUUM_CHOICE = 1,
  TIME_CHOICE = 2,
  VACUUM_PAYMENT = 3,
  VACUUM_PAYMENT_LOADING = 4,
  CHOOSE_TAX = 5,
  SEND_RECEIPT = 6,
  VACUUM_PAYMENT_SUCCESS = 7,
  VACUUM_PAYMENT_ERROR = 8,
  VACUUM_ACTIVATION_ERROR = 9,
}

export enum PAYMENT_TYPES {
  CARD_DEBIT = "debito",
  CARD_CREDIT = "credito"
}


export interface VacuumStoreInteraction {
  currPage: PAGES;
  selectedMinutes: number;
  selectedVacuum: VacuumOption;
  selectedPayment: PaymentOption;
  errorMsg: string;
  paymentId: string;
  finalPrice: number;
  taxId: string;
  cieloTransactionId: string;
}

export interface TotemVacuumStoreState extends VacuumStoreInteraction {
  vacuumOptions: VacuumOption[];
  totemId: string;
  terminalId: string;
}